import 'cio/dist/bundle.css';
import '../style/main.scss';
import '../style/oxygen.css';
import './main.js';

if (!global.Intl) {
  require('intl');
  require('intl/locale-data/jsonp/en.js');
  require('oxygen-i18n');
}



// WEBPACK FOOTER //
// ./src/js/index.js